import CustomCard from '../../../../components/CustomCard';
import { UserRestrictionItem } from './UserRestrictionItem';
import { PersonOutlinedChip, SecurityIcon } from '../../../../components/buttons/IconButtons';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const Visitors = (props) => {
    const {
        t,
        validationVisitor,
        livenessVisitor,
        biometricVisitor,
        setValidationVisitor,
        setLivenessVisitor,
        setBiometricVisitor,
    } = props;
    return (
        <div className='col-12 col-md-6 '>
            <CustomCard classCard={'card-border-8px '} classContent={'p-0'}>
                <div className={'d-flex align-items-center m-2'}>
                    <div className='h-32px w-32px'>
                        <PersonOutlinedChip className='w-h-24px' />
                    </div>
                    <p className={'fs-18px ibl-font-w-600 font-color-general-950 text-left pl-1'}>{t('visitors')}</p>
                </div>

                <div className={'border-bottom-shades-300'} />

                <CustomCard classCard={'card-border-8px  mt-3 mb-3'} classContent={'p-0'} classes={'m-2'}>
                    <div className={'d-flex align-items-center m-2'}>
                        <div className='h-32px w-32px'>
                            <SecurityIcon className='w-h-24px icon-color-general-950' />
                        </div>
                        <p className={'fs-14px ibl-font-w-600 font-color-general-950 text-left pl-1'}>
                            {t('security_validation')}
                        </p>
                    </div>
                    <div className={'border-bottom-shades-300'} />
                    <div className='m-3'>
                        <UserRestrictionItem
                           id="cb_v_require_identity_verification"
                            name='requireIdentityVerification'
                            title='require_identity_verification'
                            description='require_identity_verification_description'
                            checked={validationVisitor}
                            onChange={(e) => setValidationVisitor(e.target.checked)}
                        />
                        <UserRestrictionItem
                             id="cb_v_active_liveness"
                            name='activeLiveness'
                            title='active_liveness'
                            description='active_liveness_description'
                            checked={livenessVisitor}
                            onChange={(e) => setLivenessVisitor(e.target.checked)}
                        />
                        <UserRestrictionItem
                           id="cb_v_biometric_enforcement"
                            name='biometricEnforcement'
                            title='biometric_enforcement'
                            description='biometric_enforcement_description'
                            checked={biometricVisitor}
                            onChange={(e) => setBiometricVisitor(e.target.checked)}
                        />
                    </div>
                </CustomCard>
            </CustomCard>
        </div>
    );
};

export default Visitors;
